import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import axios from 'axios';
// import { ClerkProvider, SignedIn, SignedOut, SignOutButton, useAuth, useClerk, useUser } from '@clerk/clerk-react';
// import { Clerk } from '@clerk/clerk-js';
import { ApolloClient, InMemoryCache, ApolloProvider, split } from '@apollo/client';
import { HttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";
import Tracker from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
// import clerk from './utils/clerk';

// Pages
import Feed from './components/Feed';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Create from './pages/Create';
import Signup from './pages/Signup';
import Settings from './pages/Settings';
import Search from './pages/Search';
import PageComponent from './pages/PageComponent';
import User from './pages/User';
import Request from './pages/Request';
import ErrorPage from './pages/ErrorPage';
import MessagesPage from './pages/MessagesPage';
import UserPage from './pages/UserPage';
import SettingsAccount from './pages/settings/Account';
import SettingsSecurity from './pages/settings/Security';
import LandingPage from './pages/LandingPage';
import LandingPage2 from './pages/LandingPage2';
import TransactionsPage from './pages/Transactions';
import GroupBuysPage from './pages/GroupBuys';
import LivePage from './pages/LivePage';
import LiveChat from './pages/LiveChat';
import AdminIndex from './pages/admin/AdminIndex';
import AdminUserPage from './pages/admin/AdminUserPage';
import AdminIAP from './pages/admin/AdminIAP';
import Sandbox from './components/Sandbox';
import CreatorReq from './pages/admin/CreatorReq';
import UserManagement from './pages/admin/UserManagement';
import UserReports from './pages/admin/UserReports';
import DMCA from './pages/admin/DMCA';
import DMCACreator from './pages/DMCA';
// import Transactions from './pages/admin/Transactions';
import IOSNavbar from './components/IOSNavbar';
import CreatorPage from './pages/Creator';
import ExplorePage from './pages/Explore';
import { CourierProvider } from "@trycourier/react-provider";
import DownloadsPage from './pages/Downloads';
import ModView from './pages/modview';
import { status, getToken, init, ensureValidToken } from './hooks/AuthProvider';
import { useContributionReturn } from './hooks/useContributionReturn';
import { useSystemStatus } from './hooks/useSystemStatus';
import AppPlatformGate from './components/AppPlatformGate';
import { authClient } from './hooks/authClient';
import { getIntercomToken, clearIntercomTokenCache } from './hooks/useIntercomToken';
import Intercom, { update as intercomUpdate, shutdown as intercomShutdown } from '@intercom/messenger-js-sdk';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword'
import VerifyLogin from './pages/VerifyLogin';
import NotFound from './pages/NotFound';
import VerifyEmail from './pages/auth/VerifyEmail';
import Verify from './pages/Verify';
import AuthResetPassword from './pages/auth/AuthResetPassword';
import AcceptInvite from './pages/auth/AcceptInvite';
import AcceptTeamInvite from './pages/team/AcceptTeamInvite';
import ConfirmEmailChange from './pages/auth/ConfirmEmailChange';
import TestPage from './pages/TestPage';
import PurchasedPage from './pages/PurchasedPage';
import Analytics from './pages/Analytics';
import PrivacyPage from './pages/Privacy';
import TermsPage from './pages/Terms';
import RefundsPage from './pages/Refunds';
import ComingSoon from './pages/ComingSoon';
import CountdownPage from './pages/Countdown';
import MoonLoader from 'react-spinners/MoonLoader';
// import WatermarkTest from './pages/WatermarkTest';

// import { Logtail } from "@logtail/browser";
// const logtail = new Logtail("mgGWiuxjsNuyKtNhh9CtXaYm");

// var console=(function(oldCons){
//   return {
//       log: function(text: any){
//           oldCons.log(text);
//           // Your code
//           logtail.log(text)
//       },
//       info: function (text: any) {
//           oldCons.info(text);
//           // Your code
//           logtail.info(text)
//       },
//       warn: function (text: any) {
//           oldCons.warn(text);
//           // Your code
//           logtail.warn(text)
//       },
//       error: function (text: any) {
//           oldCons.error(text);
//           // Your code
//           logtail.error(text)
//       }
//   };
// }(window.console));

// https://www.figma.com/file/CS01VVLR7ArQl0afYFkNj3/Web-App?type=design&node-id=0-1&mode=design&t=sUKVnPNFZRgiHyP8-0

export default function App() {
  if (status()) {
    return <div className="bg-body relative min-h-screen max-h-full w-full text-white">
      <SignedInRoutes />
    </div>
  } else {
    return <SignedOutRoutes />;
  }
}

function LandingRoute({ mode }: { mode: 'coming-soon' | 'countdown' | 'landing' }) {
  if (mode === 'countdown') return <CountdownPage />;
  if (mode === 'landing') return <LandingPage />;
  return <ComingSoon />;
}

function SignedOutRoutes() {
  const { landingPage, mode, isReleased, canDownload, loading } = useSystemStatus();

  if (loading) {
    return (
      <div className="bg-body relative min-h-screen w-full flex items-center justify-center text-white">
        <MoonLoader color="#dc2626" size={40} />
      </div>
    );
  }

  return (
    <div className="bg-body relative min-h-screen max-h-full w-full text-white">
      <Router>
        <Routes>
          <Route path="/" element={<LandingRoute mode={landingPage} />} />
          <Route path="/t" element={<LandingPage2 />} />
          {canDownload && <Route path="/downloads" element={<DownloadsPage />} />}
          {/* Auth action pages — accessible from ALL platforms (email links) */}
          <Route path="/verify" element={<Verify />} />
          <Route path="/auth/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/reset-password" element={<AuthResetPassword />} />
          <Route path="/auth/accept-invite" element={<AcceptInvite />} />
          <Route path="/team/invite" element={<AcceptTeamInvite />} />
          <Route path="/auth/confirm-email-change" element={<ConfirmEmailChange />} />
          {/* Password reset — accessible from all platforms */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* Auth routes — Mac/iOS only */}
          <Route element={<AppPlatformGate />}>
            <Route path="/login" element={<Login mode={mode} />} />
            <Route path="/login/verify" element={<VerifyLogin />} />
            <Route path="/signup" element={isReleased ? <Signup mode={mode} /> : <Navigate to="/" replace />} />
          </Route>
          <Route path="/support" element={<Settings />} />
          <Route path="/changelog" element={<Settings />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refunds" element={<RefundsPage />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/countdown" element={<CountdownPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

function SignedInRoutes() {
  // const { getToken } = useAuth();  // Use Clerk's getToken
  // const [authToken, setAuthToken] = useState<string | null>(null);
  const [mainTracker, setTracker]: any = React.useState(null);
  const [tokenReady, setTokenReady] = React.useState(false);
  const { landingPage, intercomEnabled, mode, canDownload } = useSystemStatus()

  useEffect(() => {
    let cancelled = false;
    const initAuth = async () => {
      await ensureValidToken();
      if (!cancelled) {
        setTokenReady(true);
      }
    };
    initAuth();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!tokenReady) return;
    init();
  }, [tokenReady])

  useEffect(() => {
    if (!tokenReady || !intercomEnabled) return;
    let refreshIntervalId: ReturnType<typeof setInterval> | null = null;
    const bootIntercom = async () => {
      try {
        const [sessionResult, intercomAuth] = await Promise.all([
          authClient.getSession(),
          getIntercomToken(),
        ]);
        const session = sessionResult?.data;
        if (session?.user && intercomAuth.token) {
          const user = session.user as { id: string; email?: string; name?: string; displayName?: string; firstName?: string; lastName?: string; createdAt?: Date | string };
          const name = user.name ?? user.displayName ?? ([user.firstName, user.lastName].filter(Boolean).join(' ').trim() || undefined);
          const createdAt = user.createdAt != null ? Math.floor(new Date(user.createdAt).getTime() / 1000) : undefined;
          Intercom({
            app_id: 'uf03drie',
            user_id: intercomAuth.user_id,
            name: name,
            email: user.email,
            created_at: createdAt,
            user_hash: intercomAuth.token,
          });
          refreshIntervalId = setInterval(async () => {
            try {
              const { token } = await getIntercomToken();
              if (token) intercomUpdate({ user_hash: token });
            } catch {
              // Ignore refresh errors
            }
          }, 50 * 60 * 1000);
        }
      } catch (err) {
        console.error('Failed to boot Intercom:', err);
      }
    };
    bootIntercom();
    return () => {
      if (refreshIntervalId) clearInterval(refreshIntervalId);
      clearIntercomTokenCache();
      try { intercomShutdown(); } catch { /* ignore */ }
    };
  }, [tokenReady, intercomEnabled]);

  const GRAPHQLCLIENT = useMemo(() => {
    const httpLink = new HttpLink({
      uri: `${process.env.REACT_APP_API_URL}graphql`,
      credentials: "include",
    });

    const authLink = setContext(async (_, { headers }) => {
      try {
        const token = getToken();
        return {
          headers: {
            ...headers,
            'x-auth-token': token
          },
        };
      } catch (error) {
        console.error("Failed to attach token:", error);
        return { headers };
      }
    });

    const wsLink = new GraphQLWsLink(
      createClient({
        url: `${process.env.REACT_APP_API_URLWS}graphql`,
        connectionParams: async () => {
          try {
            const token = getToken();
            console.log('WebSocket connection params:', { token: token ? 'present' : 'missing' });
            return { 'x-auth-token': token || '' };
          } catch (error) {
            console.error('Error: failed to attach token to WebSocket:', error);
            return { 'x-auth-token': '' };
          }
        },
        retryAttempts: Infinity,
        shouldRetry: () => true,
        on: {
          connected: () => {
            console.log('WebSocket connected successfully');
            window.dispatchEvent(new Event('livechat-ws-connected'));
          },
          closed: () => {
            console.log('WebSocket connection closed');
            window.dispatchEvent(new Event('livechat-ws-disconnected'));
          },
          error: (error) => {
            console.error('WebSocket connection error:', error);
          },
        },
      }),
    );

    const splitLink = split(
      ({ query }) => {
        const def = getMainDefinition(query);
        return (
          def.kind === "OperationDefinition" &&
          def.operation === "subscription"
        );
      },
      wsLink,
      authLink.concat(httpLink)
    );

    return new ApolloClient({
      link: splitLink,
      cache: new InMemoryCache(),
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!tokenReady) {
    return <div className="bg-body relative min-h-screen w-full flex items-center justify-center text-white">
      <MoonLoader color="#dc2626" size={40} />
    </div>;
  }

  return <ApolloProvider client={GRAPHQLCLIENT}>
      <Router>
        <ContributionReturnHandler />
        <Routes>
          <Route path="/" element={<LandingRoute mode={landingPage} />} />
          {canDownload && <Route path="/downloads" element={<DownloadsPage />} />}
          <Route element={<AppPlatformGate />}>
            <Route path="/app/" element={<PageComponent />} >
              <Route index element={<Feed />} />
              <Route path="/app/search" element={<Search />} />
              <Route path="/app/profile" element={<Profile />} />
              <Route path="/app/create" element={<Create />} />
              <Route path="/app/user/:username" element={<User />} />
              <Route path="/app/request" element={<Request />} />
              <Route path="/app/messages" element={<MessagesPage />} />
              <Route path="/app/transactions" element={<TransactionsPage />} />
              <Route path="/app/groupbuys" element={<GroupBuysPage />} />
              <Route path="/app/creator" element={<CreatorPage />} />
              <Route path="/app/explore" element={<ExplorePage />} />
              <Route path="/app/purchased" element={<PurchasedPage />} />
              <Route path="/app/analytics" element={<Analytics />} />
              {/* <Route path="/app/dmca" element={<DMCACreator />} /> */}
            </Route>

            <Route path="/app/test" element={<TestPage />} />

            <Route path="/app/admin" element={<AdminIndex />} />
            <Route path="/app/admin/user/:username" element={<AdminUserPage />} />
            {/* <Route path="/app/admin/dmca" element={<DMCA />} /> */}
            <Route path="/app/admin/requests" element={<CreatorReq />} />
            <Route path="/app/admin/reports" element={<UserReports />} />
            <Route path="/app/admin/users" element={<UserManagement />} />
            {/* <Route path="/app/admin/iap" element={<AdminIAP />} /> */}
            {/* <Route path="/app/admin/transactions" element={<Transactions />} /> */}
            <Route path="/app/user/:username/live" element={<LivePage />} />
            <Route path="/app/user/:username/live/chat" element={<LiveChat />} />
            <Route path="/app/user/:username/live/modview" element={<ModView />} />
            <Route path="/app/settings" element={<SettingsAccount />} />
            {/* <Route path="/app/settings/security" element={<SettingsSecurity />} />
            <Route path="/app/settings/billing" element={<Settings />} />
            <Route path="/app/settings/audio" element={<Settings />} /> */}
            {/* <Route path="/signout" element={<SignOutButton redirectUrl='./' />} /> */}
          </Route>
          {/* Auth action pages — accessible from ALL platforms (email links) */}
          <Route path="/verify" element={<Verify />} />
          <Route path="/auth/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/reset-password" element={<AuthResetPassword />} />
          <Route path="/auth/accept-invite" element={<AcceptInvite />} />
          <Route path="/team/invite" element={<AcceptTeamInvite />} />
          <Route path="/auth/confirm-email-change" element={<ConfirmEmailChange />} />
          {/* Password reset — accessible from all platforms */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* Auth routes — Mac/iOS only */}
          <Route element={<AppPlatformGate />}>
            <Route path="/login" element={<Login mode={mode} />} />
            <Route path="/login/verify" element={<VerifyLogin />} />
          </Route>
          {/* <Route path="/signup" element={<Signup />} /> */}
          <Route path="/support" element={<Settings />} />
          <Route path="/changelog" element={<Settings />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refunds" element={<RefundsPage />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/countdown" element={<CountdownPage />} />
          {/* <Route path="/watermark-test" element={<WatermarkTest />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ApolloProvider>
}

function ContributionReturnHandler() {
  useContributionReturn();
  return null;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <ComingSoon />
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
